import Contact from 'help/components/contact';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import isEmail from 'sane-email-validation';
import { sendContact, toggleChat } from 'help/ducks/contact';
import { DEFAULT_REQUIRED_MESSAGE } from 'common/components/form_fields';
import {
  HELP_FORM, INVALID_EMAIL, MESSAGE_REQUIRED, ANONYMOUS_QUESTION_CATEGORIES,
  CLIENT_QUESTION_CATEGORIES, CREATIVE_QUESTION_CATEGORIES
} from 'help/constants';

export function validate(values) {
  const errors = {};

  if (!values.message) {
    errors.message = MESSAGE_REQUIRED;
  }

  if (!values.email || !isEmail(values.email)) {
    errors.email = INVALID_EMAIL;
  }

  if (!values.category) {
    errors.category = DEFAULT_REQUIRED_MESSAGE;
  }

  if (!values.payment_request_date) {
    errors.payment_request_date = DEFAULT_REQUIRED_MESSAGE;
  }

  return errors;
}

export function mapStateToProps(state, { category, message }) {
  const { help: { contact }, user } = state;
  const initialValues = {
    category: category,
    message,
  };
  const canChatOrCall = user.profile_data.is_client;
  const selector = formValueSelector(HELP_FORM);
  const selectedCategory = selector(state, 'category');

  let questionCategories = ANONYMOUS_QUESTION_CATEGORIES;
  if (user.profile_data.is_client) {
    questionCategories = CLIENT_QUESTION_CATEGORIES;
  } else if (user.profile_data.is_creative) {
    questionCategories = CREATIVE_QUESTION_CATEGORIES;
  }

  return {
    ...contact,
    canChatOrCall,
    initialValues,
    questionCategories,
    selectedCategory,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onSubmit: sendContact,
    toggleChat
  }, dispatch);
}

const ContactForm = reduxForm({
  form: HELP_FORM,
  validate,
})(Contact);

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);



// WEBPACK FOOTER //
// ./help/containers/contact.js